import { useEffect } from 'react';
import { List } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { Box, ListItem } from '/src/components';
import { useHeadlinesStore } from '/src/context';
import { Company, Lender, Loan } from '/src/lib/models';
import { TGetHeadlinesRequest } from '/src/lib/types';
import { currency } from '/src/utils';

export type HeadlinesProps = {
  /**
   * Company to retrieve headlines for
   */
  company?: Partial<Company>;
  /**
   * Loan to retrieve headlines for
   */
  loan?: Partial<Loan>;
  /**
   * Lender to retrieve headlines for
   */
  lender?: Partial<Lender>;
};

export const Headlines: React.FC<HeadlinesProps> = observer(({ company, loan, lender }) => {
  /** Computed **/
  const headlinesStore = useHeadlinesStore();

  /** Computed **/
  const headlines = headlinesStore.headlines;

  /** Methods **/

  /** Effects **/

  useEffect(() => {
    const query = {} as TGetHeadlinesRequest;

    if (loan) {
      query.companyId = loan.borrower?._id;
      query.loanId = loan._id;
    } else if (company) {
      query.companyId = company._id;
    } else if (lender) {
      query.lenderId = lender._id;
    }

    headlinesStore.get(query);
  }, [company, loan, lender]);

  /** Render **/
  const HeadlineItem = ({ label, value }: { label: string; value: string }) => (
    <ListItem sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ flex: 1 }} component="span" className="medium text-left-sm">
        {label}
      </Box>
      <Box sx={{ flex: 1 }} component="span" className="thin md-headline text-right-sm">
        {value}
      </Box>
    </ListItem>
  );

  return (
    <List sx={{ display: 'flex', flex: 1 }} className="md-subhead text-center">
      <HeadlineItem label="Asset Value" value={currency.format(headlines?.assetValue || 0)} />
      <HeadlineItem label="Principal Balance" value={currency.format(headlines?.principalBalance || 0)} />
      <HeadlineItem label="Fees Due" value={currency.format(headlines?.feesDue || 0)} />
      <HeadlineItem label="Interest Due" value={currency.format(headlines?.interestDue || 0)} />
      <HeadlineItem label="Available Credit" value={currency.format(headlines?.availableCredit || 0)} />
    </List>
  );
});
